module.exports = __webpack_public_path__ + "assets/GoldTheta2x.c2fb41b6348ae763096aee6c53855ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldTheta2x.png
// module id = 824
// module chunks = 0